import React, { useEffect, useState } from 'react';
import {
	ButtonBlockPrimary,
	ButtonPrimary,
	Layout,
	LayoutLearning,
} from '../../../components';
import { Tlearning, initialLearning } from '../../../type/learning';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getDataDetail } from '../../../service/learningService';
import YouTube from 'react-youtube';
import DynamicFaIcon from '../../../components/atoms/DynamicFaIcon';
import { formatDuration } from '../../../utls/date';
import { postData } from '../../../service/learningUsersService';
import { getMyProfile } from '../../../service/usersService';
import { Tusers, initialUsers } from '../../../type/users';
import { FaLock } from 'react-icons/fa6';
import { FiArrowRightCircle } from 'react-icons/fi';

const LearningWaitingConfirm = () => {
	const { confirm, slug } = useParams();
	const [user, setUser] = useState<Tusers>(initialUsers);
	const [learning, setLearning] = useState<Tlearning>(initialLearning);

	const getMyDataProfile = async () => {
		const response = await getMyProfile();
		if (!response?.error) {
			setUser(response?.data);
		}
	};

	const getDataLearningDetail = async (slug: string) => {
		const response = await getDataDetail(slug);
		if (!response?.error) {
			setLearning(response?.data);
			getMyDataProfile();
		}
	};

	useEffect(() => {
		getDataLearningDetail(slug || '');
	}, []);

	useEffect(() => {
		const learningAccess: string[] = [];

		learning.learningAccesses.map((item, index) => {
			learningAccess.push(item.memberType.code);
		});
	}, [user]);

	return (
		<Layout
			showNavBar
			showNavigation
			title={learning.name}
		>
			<div className="mx-4 mt-[1.3rem] background-img">
				<h1 className="ml-12 text-[16px]">{learning.name}</h1>

				<div className="flex flex-col justify-center mb-[1rem] h-[80vh] text-center">
					<h3 className="text-[26px] font-medium">
						{confirm == 'waiting' ? 'Pendaftaran Berhasil 🎉' : 'Mohon maaf 😔'}
					</h3>
					<p className="text-[14px] text-[#747688] mt-[12px]">
						{confirm == 'waiting'
							? 'Pendaftaran Anda sedang diproses. Kami akan segera mengkonfirmasi pendaftaran anda.'
							: 'Anda belum bisa mengikuti pelatihan ini.'}
					</p>
					<img
						src={
							confirm == 'waiting'
								? '/assets/imgs/confirm-waiting.svg'
								: '/assets/imgs/confirm-rejected.svg'
						}
						className="w-[150px] mx-auto mt-8"
					/>
					<Link
						to="/admin"
						className="w-[200px] mt-8 mx-auto"
					>
						<ButtonPrimary>
							<div className="w-full flex items-center justify-center gap-4">
								BACK TO HOME <FiArrowRightCircle className="text-xl" />
							</div>
						</ButtonPrimary>
					</Link>
				</div>
			</div>
		</Layout>
	);
};

export default LearningWaitingConfirm;
